{
  "table": {
    "complianceState": "État de conformité",
    "complianceStateOptions": {
      "ANY": "Peu importe",
      "APPROVED": "Approuvé",
      "NEEDS_REVIEW": "Examen requis",
      "REJECTED": "Refusé"
    },
    "accountType": "Type de compte",
    "state": "État",
    "stateOptions": {
      "ANY": "Peu importe",
      "ACTIVE": "Actif",
      "AWAITING_APPROVAL": "Approbation en attente",
      "INACTIVE": "Inactif"
    },
    "iDVerified": "Identité vérifiée",
    "idVerifiedOptions": {
      "ANY": "Peu importe",
      "YES": "Oui",
      "NO": "Non"
    },
    "organization": "Organisation",
    "client": "Client",
    "account": "Compte",
    "age": "Âge",
    "annualIncome": "Revenu annuel",
    "annualDebtPayments": "Paiements annuels des dettes",
    "totalDebt": "Dette totale",
    "liquidAssets": "Liquidités",
    "totalAssets": "Total des actifs",
    "netWorth": "Valeur nette",
    "debtAssetRatio": "Ratio d'endettement",
    "debtServiceRatio": "Ratio de remboursement",
    "employment": "Emploi",
    "jobTitle": "Titre du poste",
    "companyType": "Type d'entreprise",
    "entityOfInterest": "Personne ou entité concernée",
    "userSuitablitiy": "Score d'adéquation de l'utilisateur",
    "goalSuitability": "Score d'adéquation de l'objectif",
    "suggestedPortfolio": "Suggestion de portefeuille",
    "idVerified": "Identité vérifiée",
    "actualPortfolio": "Portefeuille",
    "completedAt": "Terminé à",
    "subAccountStatus": "État du sous-compte",
    "actions": "Actions",
    "yes": "Oui",
    "no": "Non",
    "new": "Nouveau",
    "updated": "Mis à jour",
    "isVulnerablePerson": "Personne vulnérable",
    "isOwnerOfEntity": "Propriétaire de l'entité"
  },
  "approveAndSign": "Approuver et signer",
  "inherited": "Hérité - "
}
